import { isIsoDate } from '@aladin/shared-common-sdk';
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
export function transformResponse(data) {
    if (data === null || data === undefined) {
        return data;
    }
    return JSON.parse(data, (_key, value) => {
        if (isIsoDate(value)) {
            return new Date(value);
        }
        return value;
    });
}
//# sourceMappingURL=transform-response.js.map